// Updated to include Saturday for schedule entries
export const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

// Define the time slots for the column markers
export const timeSlots = [
    '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00',
    '16:00', '17:00', '18:00', '19:00', '20:00', '21:00' // Covers up to 21:59
];

// Define the visual range of the schedule day in minutes from midnight
// Example: 08:00 to 15:00 (one hour past last slot for visual space)
export const SCHEDULE_START_MINUTE = 9 * 60; // 08:00
export const SCHEDULE_END_MINUTE = 22 * 60; // 15:00
export const TOTAL_SCHEDULE_MINUTES = SCHEDULE_END_MINUTE - SCHEDULE_START_MINUTE;

// Resize configuration constants
export const RESIZE_CONFIG = {
  minDurationMinutes: 15,
  snapIntervalMinutes: 15,
  fineAdjustmentKey: 'shift',
  fineAdjustmentInterval: 1,
  handleHeight: 8, // pixels
  handleVisibilityThreshold: 30 // pixels - minimum card height to show resize handles
};

// Drag and drop configuration constants
export const DRAG_CONFIG = {
  timeSnapIntervalMinutes: 15, // Time intervals for dragging schedule items
  dragThreshold: 5 // pixels - minimum movement to start drag
};
